import { Link } from 'react-router-dom';

export const BlogsPost_Data = {
    "marvel-at-new-parliament-house": {

        Meta_title: 'Marvel at New Parliament House | Marvel Blinds',
        OG_title: 'Marvel at New Parliament House',
        Meta_Description: '“Marvel” Got the opportunity to install their Window Coverings products to the New Parliament House',
        OG_Description: '“Marvel” Got the opportunity to install their Window Coverings products to the New Parliament House',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/blog/marvel-at-new-parliament-house`,


        Blog_Title: "Marvel at New Parliament House",
        Blog_post_content: (
            <>
                <p>
                    “Marvel” Got the opportunity to install their Window Coverings products to the New Parliament House
                </p>
                <p>
                    In a momentous occasion that will be etched in the annals of history, Marvel Decor Ltd., a renowned company in the realm of manufacturing Window Coverings had the distinct honour of making a significant contribution to the splendid New Parliament House. This iconic structure, inaugurated today by the esteemed Prime Minister Shri Narendra Modi, stands as a testament to India’s progress and vision for the future.
                </p>
                <img src="/Assets/BlogPost_Images/Image1.jpg" />

                <p>
                    HCP Architects have chosen Marvel and its product with utmost detailing and analysis. The project displays unique mechanism of Roman Blinds whose fabric is custom made of 10% cotton and 90% polyester. Marvel’s Roman Blinds are specially engineered to give a Traditional yet a Modern look with its sleek designing.
                </p>
                <p>
                    Marvel Decor Ltd., an SME listed in the NSE is a leading company specializing in Window Covering Solutions whose infrastructure is spread across 2 lakh sq. ft. with ultra-modern facilities at Jamnagar, Gujarat. It takes pride in having the world’s largest range of products in the industry. With a reputation for innovation, quality, and unmatched attention to detail, the company has established itself as a trusted name in the industry.
                </p>
                <p>
                    Marvel is the only Indian company in the industry which went globally with their own brand “Callistus” and have established a full-fledged assembling unit in Dubai having 70+ employees which supplies its products to USA, Canada and UK in addition to the GCC market. Marvel has 500+ Channel Partners out of India and has 400+ Channel Partner network in 237 cities within India. Marvel continues to spread its wings to the world with its subsidiary Company “Callistus Blinds Middle East FZE”
                </p>
                <p>
                    “We are immensely proud to have been entrusted with the responsibility of enhancing the visual splendour of the New Parliament House,” said Mr. Ashok Paun Founder and Managing Director of Marvel Decor Ltd. “Our team has worked tirelessly to ensure that our Window Coverings complement the majestic ambiance of this historic institution. It is an honour to contribute to a landmark that will shape the destiny of our nation.”
                </p>
                <p>
                    Click to see video – <Link to="https://youtu.be/pNgqbRiItMg">https://youtu.be/pNgqbRiItMg</Link>
                </p>
                <img src="/Assets/BlogPost_Images/Image2.jpg" />
            </>
        )
    },
}

